// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-sub-menu_sub_menu_box__FvK3g {
    right: 0;
    z-index: 3;
    width: 100%;
    height: 500px;
    position: fixed;
    max-width: 300px;
    overflow: hidden;
    margin-top: 130px;
    margin-right: -500px;
    font-family: "Gothic";
    border: 3px solid #ADB2A1;
    border-right: none;
    background-color: #7B8073;
    transition: margin-right 0.5s;
    border-radius: 50px 0px 0px 50px;
}
.mobile-sub-menu_sub_menu_box__FvK3g.mobile-sub-menu_open__FPT5t {
    margin-right: 0;
}

.mobile-sub-menu_tittle_box__SR2qw p {
    font-size: 20px;
    color: #223300;
    margin-top: 31px;
    margin-bottom: 0;
}

.mobile-sub-menu_icon_box__cRys6 {
    width: 40px;
    height: 40px;
    display: flex;
    margin-top: 40px;
    margin-right: 40px;
    margin-bottom: 30px;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background-color: #191A17;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    -webkit-tap-highlight-color: transparent;
}

.mobile-sub-menu_icon_box__cRys6:active {
    animation: mobile-sub-menu_click-up__qHhA3 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.mobile-sub-menu_icon_box__cRys6 img {
    width: 30px;
    height: 30px;
}

.mobile-sub-menu_options_button_box__0lSt\\+ button {
    width: 220px;
    height: 40px;
    font-size: 16px;
    color: #FFFFFF;
    border-radius: 50px;
    margin-bottom: 15px;
    transition: transform 0.3s;
    background-color: #474D3D;
}
.mobile-sub-menu_options_button_box__0lSt\\+ button:hover {
    transform: translateY(-8px);
}

.mobile-sub-menu_fotter_box__tPpPK p {
    margin: 0;
    font-size: 10px;
    color: #111A00;
    margin-top: 15px;
}

@keyframes mobile-sub-menu_click-up__qHhA3 {
  0% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0);
  }
}

@media (min-width: 1200px) {
    .mobile-sub-menu_sub_menu_box__FvK3g {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/mobile-sub-menu/mobile-sub-menu.module.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,6EAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".sub_menu_box {\r\n    right: 0;\r\n    z-index: 3;\r\n    width: 100%;\r\n    height: 500px;\r\n    position: fixed;\r\n    max-width: 300px;\r\n    overflow: hidden;\r\n    margin-top: 130px;\r\n    margin-right: -500px;\r\n    font-family: \"Gothic\";\r\n    border: 3px solid #ADB2A1;\r\n    border-right: none;\r\n    background-color: #7B8073;\r\n    transition: margin-right 0.5s;\r\n    border-radius: 50px 0px 0px 50px;\r\n}\r\n.sub_menu_box.open {\r\n    margin-right: 0;\r\n}\r\n\r\n.tittle_box p {\r\n    font-size: 20px;\r\n    color: #223300;\r\n    margin-top: 31px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.icon_box {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    margin-top: 40px;\r\n    margin-right: 40px;\r\n    margin-bottom: 30px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 10px;\r\n    background-color: #191A17;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.icon_box:active {\r\n    animation: click-up 0.3s cubic-bezier(0.25, 1, 0.5, 1);\r\n}\r\n\r\n.icon_box img {\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.options_button_box button {\r\n    width: 220px;\r\n    height: 40px;\r\n    font-size: 16px;\r\n    color: #FFFFFF;\r\n    border-radius: 50px;\r\n    margin-bottom: 15px;\r\n    transition: transform 0.3s;\r\n    background-color: #474D3D;\r\n}\r\n.options_button_box button:hover {\r\n    transform: translateY(-8px);\r\n}\r\n\r\n.fotter_box p {\r\n    margin: 0;\r\n    font-size: 10px;\r\n    color: #111A00;\r\n    margin-top: 15px;\r\n}\r\n\r\n@keyframes click-up {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-6px);\r\n  }\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .sub_menu_box {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sub_menu_box": `mobile-sub-menu_sub_menu_box__FvK3g`,
	"open": `mobile-sub-menu_open__FPT5t`,
	"tittle_box": `mobile-sub-menu_tittle_box__SR2qw`,
	"icon_box": `mobile-sub-menu_icon_box__cRys6`,
	"click-up": `mobile-sub-menu_click-up__qHhA3`,
	"options_button_box": `mobile-sub-menu_options_button_box__0lSt+`,
	"fotter_box": `mobile-sub-menu_fotter_box__tPpPK`
};
export default ___CSS_LOADER_EXPORT___;
